import { Session, Settings } from "./api/types";
import { DxAPIConnector } from "./api";
import { useGlobalConfigsStore } from "./storeModules/globalConfigs/globalConfigs";
import { useUserConfigStore } from "./storeModules/userConfigs";

export const isUserAuthenticated = async () => {
  console.log("isUserAuthenticated");
  const userData = window.localStorage.getItem("prominent.userData");
  if (!userData) {
    console.log("isUserAuthenticated --> no userData --> false");
    return false;
  }

  const globalConfigStore = useGlobalConfigsStore();
  const userConfigStore = useUserConfigStore();

  const userObject = JSON.parse(atob(userData)) as Session;
  globalConfigStore.$patch({
    session: userObject.id,
  });
  const connector = new DxAPIConnector("", userObject.id);

  console.log("isUserAuthenticated --> try block");
  const isSessionValid = await connector.general.getSettings();
  console.log("isUserAuthenticated --> try block --> after getSession");

  if (typeof isSessionValid === "string") {
    console.log("isUserAuthenticated --> try block --> isSessionValid.startsWith('error'): " + isSessionValid + "--> false");
    return false;
  }
  globalConfigStore.$patch({
    connector,
    isAuth: true,
  });
  userConfigStore.$patch({
    userData: userObject,
    userSettings: isSessionValid,
  });
  console.log("isUserAuthenticated --> try block --> after store patch --> TRUE");

  return true;
};